"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var Button_1 = __importDefault(require("stremio/components/Button"));
var EPG_1 = require("stremio/common/EPG");
var useScheduleViewport_1 = __importDefault(require("./useScheduleViewport"));
var Agenda_1 = __importDefault(require("./Agenda"));
var Timeline_1 = __importDefault(require("./Timeline"));
var Schedule_less_1 = __importDefault(require("./Schedule.less"));
var Schedule = function (_a) {
    var _b;
    var programs = _a.programs, now = _a.now, selected = _a.selected, onProgramSelect = _a.onProgramSelect;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _c = (0, react_1.useState)('agenda'), view = _c[0], setView = _c[1];
    var agendaRef = (0, react_1.useRef)(null);
    var agendaScrollRef = (0, react_1.useRef)('start');
    var start = programs.length > 0 ? (0, EPG_1.epgDayWindow)(programs[0].startTime).start : 0;
    var end = programs.reduce(function (latest, program) { return Math.max(latest, program.endTime.getTime()); }, start);
    var active = (_b = programs.find(function (program) { return program.endTime.getTime() > now; })) !== null && _b !== void 0 ? _b : programs[programs.length - 1];
    var selectedIndex = selected ? programs.indexOf(selected) : -1;
    var canGoBack = selectedIndex > 0;
    var canGoForward = selectedIndex < programs.length - 1;
    var _d = (0, useScheduleViewport_1.default)(start, view === 'timeline'), viewportRef = _d.viewportRef, viewport = _d.viewport, scale = _d.scale, zoom = _d.zoom, focus = _d.focus, showTime = _d.showTime, canZoomOut = _d.canZoomOut, canZoomIn = _d.canZoomIn;
    var revealAgenda = (0, react_1.useCallback)(function () {
        if (agendaScrollRef.current === null)
            return;
        var element = agendaRef.current;
        var row = element === null || element === void 0 ? void 0 : element.querySelector('[aria-pressed="true"]');
        if (!element || !row || element.clientHeight === 0)
            return;
        var style = window.getComputedStyle(element);
        var top = row.offsetTop - (parseFloat(style.scrollPaddingTop) || 0);
        var bottom = row.offsetTop + row.offsetHeight + (parseFloat(style.scrollPaddingBottom) || 0);
        if (agendaScrollRef.current === 'start' || top < element.scrollTop) {
            element.scrollTop = top;
        }
        else if (bottom > element.scrollTop + element.clientHeight) {
            element.scrollTop = bottom - element.clientHeight;
        }
        agendaScrollRef.current = null;
    }, []);
    (0, react_1.useLayoutEffect)(revealAgenda, [selected === null || selected === void 0 ? void 0 : selected.id, selected === null || selected === void 0 ? void 0 : selected.startTime.getTime(), view, revealAgenda]);
    var select = function (program) {
        agendaScrollRef.current = program ? 'nearest' : 'start';
        onProgramSelect(program);
        var target = program !== null && program !== void 0 ? program : active;
        if (view === 'timeline') {
            if (program)
                focus(program);
            else
                showTime(now);
        }
        else if (target === selected) {
            revealAgenda();
        }
    };
    var changeView = function (nextView) {
        if (nextView === view)
            return;
        if (nextView === 'agenda')
            agendaScrollRef.current = 'start';
        setView(nextView);
        if (nextView === 'timeline' && selected) {
            if (selected.startTime.getTime() <= now && now < selected.endTime.getTime())
                showTime(now);
            else
                focus(selected);
        }
    };
    var onPreviousProgram = function () { return select(programs[selectedIndex - 1]); };
    var onNextProgram = function () { return select(programs[selectedIndex + 1]); };
    var onNow = function () { return select(null); };
    var onZoomOut = function () { return zoom(0.5); };
    var onZoomIn = function () { return zoom(2); };
    var onFitSelected = function () {
        if (selected)
            focus(selected, true);
    };
    return (react_1.default.createElement("div", { className: Schedule_less_1.default['schedule'], "aria-label": t('LIVE_TV_SCHEDULE', { defaultValue: 'Programme guide' }) },
        react_1.default.createElement("div", { className: Schedule_less_1.default['header'] },
            react_1.default.createElement("div", { className: Schedule_less_1.default['title'] }, t('LIVE_TV_SCHEDULE', { defaultValue: 'Programme guide' })),
            programs.length > 0 ?
                react_1.default.createElement("div", { className: Schedule_less_1.default['view-controls'] },
                    react_1.default.createElement(Button_1.default, { role: 'button', "aria-pressed": view === 'agenda', onClick: function () { return changeView('agenda'); } }, t('LIVE_TV_AGENDA', { defaultValue: 'Agenda' })),
                    react_1.default.createElement(Button_1.default, { role: 'button', "aria-pressed": view === 'timeline', onClick: function () { return changeView('timeline'); } }, t('LIVE_TV_TIMELINE', { defaultValue: 'Timeline' })))
                :
                    null),
        programs.length > 0 ?
            react_1.default.createElement("div", { className: Schedule_less_1.default['navigation'] },
                react_1.default.createElement("div", { className: Schedule_less_1.default['program-navigation'] },
                    react_1.default.createElement(Button_1.default, { role: 'button', "aria-label": t('LIVE_TV_PREVIOUS_PROGRAM', { defaultValue: 'Previous programme' }), disabled: !canGoBack, "aria-disabled": !canGoBack, tabIndex: canGoBack ? 0 : -1, onClick: onPreviousProgram },
                        react_1.default.createElement(react_2.default, { name: 'chevron-back' })),
                    react_1.default.createElement(Button_1.default, { role: 'button', onClick: onNow }, t('LIVE_TV_NOW', { defaultValue: 'Now' })),
                    react_1.default.createElement(Button_1.default, { role: 'button', "aria-label": t('LIVE_TV_NEXT_PROGRAM', { defaultValue: 'Next programme' }), disabled: !canGoForward, "aria-disabled": !canGoForward, tabIndex: canGoForward ? 0 : -1, onClick: onNextProgram },
                        react_1.default.createElement(react_2.default, { name: 'chevron-forward' }))),
                react_1.default.createElement("div", { className: Schedule_less_1.default['zoom-controls'], "aria-hidden": view !== 'timeline' },
                    react_1.default.createElement(Button_1.default, { role: 'button', "aria-label": t('LIVE_TV_ZOOM_OUT', { defaultValue: 'Zoom out' }), disabled: !canZoomOut, "aria-disabled": !canZoomOut, tabIndex: canZoomOut ? 0 : -1, onClick: onZoomOut },
                        react_1.default.createElement("div", { className: Schedule_less_1.default['zoom-icon'], "aria-hidden": 'true' })),
                    react_1.default.createElement(Button_1.default, { role: 'button', onClick: onFitSelected }, t('LIVE_TV_FIT_SELECTED', { defaultValue: 'Fit selected' })),
                    react_1.default.createElement(Button_1.default, { role: 'button', "aria-label": t('LIVE_TV_ZOOM_IN', { defaultValue: 'Zoom in' }), disabled: !canZoomIn, "aria-disabled": !canZoomIn, tabIndex: canZoomIn ? 0 : -1, onClick: onZoomIn },
                        react_1.default.createElement("div", { className: (0, classnames_1.default)(Schedule_less_1.default['zoom-icon'], Schedule_less_1.default['zoom-in']), "aria-hidden": 'true' }))))
            :
                null,
        react_1.default.createElement(Agenda_1.default, { ref: agendaRef, programs: programs, now: now, selected: selected, visible: view === 'agenda' && programs.length > 0, onSelect: select }),
        react_1.default.createElement(Timeline_1.default, { viewportRef: viewportRef, viewport: viewport, scale: scale, start: start, end: end, programs: programs, now: now, selected: selected, visible: view === 'timeline' && programs.length > 0, onSelect: onProgramSelect }),
        programs.length === 0 ?
            react_1.default.createElement("div", { className: Schedule_less_1.default['empty'] },
                react_1.default.createElement(react_2.default, { name: 'calendar' }),
                react_1.default.createElement("div", null, t('LIVE_TV_NO_SCHEDULE', { defaultValue: 'Programme information is unavailable for this channel.' })))
            :
                null));
};
exports.default = Schedule;
